<template>
  <div>
    <popup-add-product
      v-if="order"
      ref="popupAddProduct"
      @productSelected="productSelected"
      :existingProducts="order.orderLines"
      :assignedStockProducts="assignedStockProducts"
    />

    <RightSidebar :isActive.sync="isActive" size="large">
      <template #header>
        <img width="40" :src="OrderIcon" class="mr-4" />
        <div>
          <div class="flex items-center">
            <div><h4>Purchase order</h4></div>
            <vs-chip v-if="order" :color="stateMapping[order.status].color" class="ml-2">
              {{ stateMapping[order.status].label }}
            </vs-chip>
          </div>
          <small v-if="order">{{ order.id }}</small>
        </div>
      </template>

      <template #content>
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <h3 class="ml-4 mb-2">Order lines</h3>

          <div class="mx-6 data-list-list-view compact-table table-primary-bg">
            <vs-table :data="order.orderLines" style="margin-left: -24px; margin-right: -24px" noDataText="">
              <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
              <template slot="thead">
                <vs-th>Product</vs-th>
                <vs-th>Puom size</vs-th>
                <vs-th>Order amount</vs-th>
                <vs-th>New stock balance</vs-th>
                <vs-th>Line price</vs-th>
                <vs-th v-if="isEditable"></vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="tr.id" v-for="tr in data" :state="tr.orderCases == 0 ? 'danger' : ''">
                  <vs-td>
                    <div class="product-name font-medium truncate flex flex-row items-center">
                      <div class="flex flex-col">
                        <div class="whitespace-nowrap overflow-hidden truncate" style="width: 206px">
                          {{ tr.stockProduct.name }}
                        </div>
                        <div class="flex items-center">
                          <div class="text-sm text-grey">
                            {{ tr.stockProduct.number }} •
                            {{ tr.stockProduct.productGroupId }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td>
                    <div>
                      <div>
                        {{ tr.stockProduct.caseSize }}
                        {{ tr.stockProduct.productUnit }}
                      </div>
                      <div class="text-sm">
                        {{ (tr.stockProduct.caseSize * tr.stockProduct.unitPrice).toFixed(2) }}
                        DKK
                      </div>
                    </div>
                  </vs-td>

                  <vs-td>
                    <NumberInput
                      v-model="tr.puomQuantity"
                      unit="puom"
                      style="width: 120px"
                      :compact="true"
                      :disabled="!isEditable"
                      :min="0"
                    />
                  </vs-td>

                  <vs-td>
                    <div class="flex">
                      <code class="whitespace-no-wrap">
                        {{ getCurrentStockBalance(tr).amount | formatDecimal(1) }}
                        <span>/</span>
                        {{ getCurrentStockBalance(tr).minimum }}
                      </code>
                      <!-- <div class="ml-1">
                        <small
                          >{{ getCurrentStockBalance(tr).percentage }} %</small
                        >
                      </div> -->
                    </div>
                    <div>
                      <vs-progress
                        :height="10"
                        :percent="getCurrentStockBalance(tr).percentage"
                        :color="getCurrentStockBalance(tr).color"
                      ></vs-progress>
                    </div>
                  </vs-td>

                  <vs-td>
                    <vx-tooltip
                      :text="`Calculated as: ${tr.stockProduct.caseSize} ${tr.stockProduct.productUnit} • ${tr.puomQuantity} puom • ${
                        tr.stockProduct.unitPrice
                      } DKK = ${calculateLinePrice(tr.stockProduct, tr.puomQuantity)} DKK`"
                    >
                      <b>{{ calculateLinePrice(tr.stockProduct, tr.puomQuantity) | numberFormatDK }} DKK</b>
                      <feather-icon icon="InfoIcon" svgClasses="w-3 h-4" class="ml-1" />
                    </vx-tooltip>
                    <!-- <span>{{
                      parseFloat(
                        tr.orderCases * tr.caseSize * tr.unitPrice
                      ).toFixed(2)
                    }}</span> -->
                  </vs-td>

                  <vs-td v-if="isEditable">
                    <feather-icon
                      @click="removeProduct(tr.stockProductId)"
                      icon="TrashIcon"
                      class="cursor-pointer mr-2"
                      svgClasses="h-5 w-5 stroke-2"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
            <div class="flex justify-between mt-2">
              <div>
                <b>Order total: {{ orderTotal | numberFormatDK }} DKK</b>
              </div>
              <vs-button v-if="isEditable" class="ml-2 py-2 px-3" @click="$refs.popupAddProduct.show()" type="border">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4 pt-1" />
                <span class="ml-1">Add order line</span>
              </vs-button>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <vs-button class="mr-4" @click="save" :disabled="!isFormValid"> Save </vs-button>

        <vs-button v-if="isEditable" type="border" class="ml-auto" @click="submitOrder">Send Order</vs-button>
        <!-- <vs-button class="mr-4" @click="onClickPreview"> Preview </vs-button> -->
        <!-- <vs-button color="danger" v-if="isDeleteable" @click="confirmDelete">
          Delete
        </vs-button> -->
      </template>
    </RightSidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import OrderIcon from "@/assets/images/order-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddAssignedStockProduct.vue";
import RightSidebar from "@/components/Custom/RightSidebar.vue";
import NumberInput from "@/components/Custom/NumberInput.vue";

export default {
  components: {
    VuePerfectScrollbar,
    PopupAddProduct,
    RightSidebar,
    NumberInput
  },
  data() {
    return {
      OrderIcon,

      isActive: false,
      isLoading: true,

      order: null
    };
  },
  computed: {
    ...mapGetters({
      stateMapping: "pos/purchaseOrders/stateMapping",
      assignedStockProducts: "pos/assignedStockProducts/assignedStockProducts"
    }),

    isFormValid() {
      return true;
    },
    isEditable() {
      return this.order && this.order.status === "Draft";
    },
    isDeleteable() {
      return this.order && (this.order.status === "Draft" || this.order.status === "Active");
    },

    orderTotal() {
      if (!this.order) return 0;

      return this.order.orderLines.reduce((acc, cur) => {
        return acc + this.calculateLinePrice(cur.stockProduct, cur.puomQuantity);
      }, 0);
    }
  },
  methods: {
    getCurrentStockBalance(orderLine) {
      // console.log(
      //   "orderLine",
      //   orderLine,
      //   orderLine.stockProductId,
      //   JSON.parse(JSON.stringify(this.assignedStockProducts)),
      //   this.assignedStockProducts.map(e => e.id)
      // );
      const assignedStockProduct = this.assignedStockProducts.find(x => x.stockProductId === orderLine.stockProductId);

      const amount = assignedStockProduct.venueAmount + orderLine.puomQuantity * assignedStockProduct.stockProduct.caseSize;

      const percentage = (amount / assignedStockProduct.venueMinimumAmount) * 100;

      return {
        amount: amount,
        minimum: assignedStockProduct.venueMinimumAmount,
        percentage: percentage,
        color: percentage < 40 ? "danger" : percentage < 100 ? "warning" : "primary"
      };
    },

    calculateLinePrice(stockProduct, puomQuantity) {
      return puomQuantity * stockProduct.caseSize * stockProduct.unitPrice;
    },

    removeProduct(id) {
      this.order.orderLines = this.order.orderLines.filter(x => x.stockProduct.id !== id);
    },
    productSelected(orderLine) {
      // Don't add if already exists
      if (this.order.orderLines.find(x => x.stockProduct.id === orderLine.stockProduct.id)) {
        return;
      }

      this.order.orderLines.push({ ...orderLine, puomQuantity: orderLine.neededPuom });
    },
    async showOrder(orderId) {
      this.isActive = true;
      this.isLoading = true;

      var result = await this.$store.dispatch("pos/purchaseOrders/getPurchaseOrder", orderId);

      this.order = result;

      await this.loadExternalData();
      console.log("Got order", this.order);
      this.isLoading = false;
    },
    async loadExternalData() {
      await this.$store.dispatch("pos/assignedStockProducts/getAssignedStockProductsByVenue", this.order.venueId);
      console.log("Total venue order lines", this.venueOrderLines);
    },
    // confirmDelete() {
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: `Confirm`,
    //     text: `Are you sure you want to cancel this order? It will still be visible, but will be marked as cancelled.`,
    //     accept: async () => {
    //       try {
    //         console.log("Deleting order", this.orgOrder, this.activeVenueId);
    //         await this.$store.dispatch("orders/cancelOrder", this.orgOrder.id);
    //         await this.$store.dispatch(
    //           "orders/getOrders",
    //           this.orgOrder.venueId.id
    //         );

    //         this.$vs.notify({
    //           title: "Order cancelled",
    //           text: "Your order has been cancelled.",
    //         });

    //         this.isActive = false;
    //         this.order = null;
    //         this.orgOrder = null;
    //         this.isLoading = true;
    //       } catch (err) {
    //         this.$vs.notify({
    //           title: "Error",
    //           text: `Failed to cancel order: ${err}`,
    //         });
    //         console.error(err);
    //       }
    //     },
    //   });
    // },
    async save() {
      console.log("Saving DTO", this.order);

      try {
        const result = await this.$store.dispatch("pos/purchaseOrders/updatePurchaseOrder", {
          purchaseOrderId: this.order.id,
          purchaseOrderDto: {
            orderLines: this.order.orderLines.map(e => {
              return {
                stockProductId: e.stockProductId,
                puomQuantity: e.puomQuantity
              };
            })
          }
        });
        await this.$store.dispatch("pos/purchaseOrders/getPurchaseOrdersByVenue", this.order.venueId);

        // await this.showOrder(this.order.id); // Refresh order line totals for this view

        this.$vs.notify({
          title: "Order saved",
          text: "Your order has been saved."
        });
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to save order: ${err}`,
          color: "danger"
        });
      }
    },

    async submitOrder() {
      try {
        await this.$store.dispatch("pos/purchaseOrders/updatePurchaseOrder", {
          purchaseOrderId: this.order.id,
          purchaseOrderDto: {
            orderLines: this.order.orderLines.map(e => {
              return {
                stockProductId: e.stockProductId,
                puomQuantity: e.puomQuantity
              };
            })
          }
        });

        await this.$store.dispatch("pos/purchaseOrders/submitPurchaseOrder", this.order.id);
        await this.$store.dispatch("pos/purchaseOrders/getPurchaseOrdersByVenue", this.order.venueId);

        this.$vs.notify({
          title: "Order sent",
          text: "Your order has been sent."
        });

        this.isActive = false;
        this.isLoading = true;
        this.order = null;
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to send order: ${err}`,
          color: "danger"
        });
      }
    }
  }
};
</script>
